import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from './ThemeContext';
import { AuthProvider, useAuth } from './AuthContext';
import './i18n/config';

// Components
import Login from './components/Login';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Assets from './components/Assets';
import AssetDetail from './components/AssetDetail';
import WorkOrders from './components/WorkOrders';
import WorkOrderDetail from './components/WorkOrderDetail';
import PMSchedules from './components/PMSchedules';
import Users from './components/Users';
import QRCodePrint from './components/QRCodePrint';
import MaintenanceRequest from './components/MaintenanceRequest';
import PublicWorkOrder from './components/PublicWorkOrder';
import EmailSetup from './components/EmailSetup';
import RoleManagement from './components/RoleManagement';
import ColumnSettings from './components/ColumnSettings';
import SetupPassword from './components/SetupPassword';

function PrivateRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" />;
  }

  return children;
}

function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/setup-password" element={<SetupPassword />} />
          <Route path="/maintenance-request/:assetNumber" element={<MaintenanceRequest />} />
          <Route path="/submit-work-order" element={<PublicWorkOrder />} />
          <Route path="/submit-work-order/location/:locationName" element={<PublicWorkOrder />} />
          <Route path="/submit-work-order/:assetNumber" element={<PublicWorkOrder />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="assets" element={<Assets />} />
            <Route path="assets/:id" element={<AssetDetail />} />
            <Route path="work-orders" element={<WorkOrders />} />
            <Route path="work-orders/:id" element={<WorkOrderDetail />} />
            <Route path="pm-schedules" element={<PMSchedules />} />
            <Route
              path="users"
              element={
                <PrivateRoute roles={['administrator']}>
                  <Users />
                </PrivateRoute>
              }
            />
            <Route path="qr-codes" element={<QRCodePrint />} />
            <Route
              path="email-setup"
              element={
                <PrivateRoute roles={['administrator']}>
                  <EmailSetup />
                </PrivateRoute>
              }
            />
            <Route
              path="role-management"
              element={
                <PrivateRoute roles={['administrator']}>
                  <RoleManagement />
                </PrivateRoute>
              }
            />
            <Route
              path="column-settings"
              element={
                <PrivateRoute roles={['administrator']}>
                  <ColumnSettings />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
